module.exports = __webpack_public_path__ + "static/img/bonus_3.665b851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/bonus_3.png
// module id = fZO7
// module chunks = 0